import React, { useEffect, useState } from "react";
import { api, formatMXN } from "../../lib/api";
import { toast } from "sonner";

const STATUSES = ["pending", "confirmed", "shipped", "delivered", "cancelled"];

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [open, setOpen] = useState(null);

  const load = async () => { const { data } = await api.get("/admin/orders"); setOrders(data); };
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    await api.put(`/admin/orders/${id}`, { status });
    toast.success("Estado actualizado"); load();
  };

  return (
    <div data-testid="admin-orders-page">
      <h1 className="font-serif text-5xl tracking-tighter">Pedidos</h1>
      <p className="text-[#5B605E] mt-1">{orders.length} pedidos registrados.</p>

      <div className="bg-white border border-[#E8E3DA] mt-8">
        <table className="w-full text-sm">
          <thead className="bg-[#F2EFE9] text-left text-[10px] uppercase tracking-wider text-[#5B605E]">
            <tr>
              <th className="px-4 py-3">Pedido</th>
              <th className="px-4 py-3">Cliente</th>
              <th className="px-4 py-3">Total</th>
              <th className="px-4 py-3">Pago</th>
              <th className="px-4 py-3">Estado</th>
              <th className="px-4 py-3">Fecha</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.id} className="border-t border-[#E8E3DA] cursor-pointer hover:bg-[#F2EFE9]" onClick={() => setOpen(o)}>
                <td className="px-4 py-3 font-mono text-xs">#{o.id.slice(0, 8)}</td>
                <td className="px-4 py-3">{o.shipping?.full_name}<div className="text-xs text-[#5B605E]">{o.email}</div></td>
                <td className="px-4 py-3">{formatMXN(o.total)}</td>
                <td className="px-4 py-3">
                  <span className={`text-xs px-2 py-1 ${o.payment_status === "paid" ? "bg-[#4A6B53] text-white" : "bg-[#F2EFE9]"}`}>{o.payment_status}</span>
                </td>
                <td className="px-4 py-3">
                  <select onClick={(e) => e.stopPropagation()} value={o.status} onChange={(e) => updateStatus(o.id, e.target.value)} className="border border-[#2C302E] bg-transparent px-2 py-1 text-xs">
                    {STATUSES.map((s) => <option key={s}>{s}</option>)}
                  </select>
                </td>
                <td className="px-4 py-3 text-xs">{new Date(o.created_at).toLocaleDateString("es-MX")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {open && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" onClick={() => setOpen(null)}>
          <div className="bg-[#F9F6F0] max-w-2xl w-full p-8 max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <h2 className="font-serif text-3xl tracking-tighter">Pedido #{open.id.slice(0, 8)}</h2>
            <p className="text-sm text-[#5B605E] mt-1">{new Date(open.created_at).toLocaleString("es-MX")}</p>

            <div className="grid grid-cols-2 gap-4 mt-6 text-sm">
              <div>
                <p className="text-[10px] uppercase tracking-wider text-[#5B605E]">Cliente</p>
                <p>{open.shipping.full_name}</p>
                <p>{open.email}</p>
                <p>{open.shipping.phone}</p>
              </div>
              <div>
                <p className="text-[10px] uppercase tracking-wider text-[#5B605E]">Envío</p>
                <p>{open.shipping.address}</p>
                <p>{open.shipping.city}, {open.shipping.country}</p>
              </div>
            </div>

            <h3 className="font-serif text-xl mt-6 mb-2">Productos</h3>
            <ul className="space-y-2 text-sm">
              {open.items.map((it, i) => (
                <li key={i} className="flex justify-between border-b border-[#E8E3DA] py-2">
                  <span>{it.name} × {it.qty}</span>
                  <span>{formatMXN(it.price * it.qty)}</span>
                </li>
              ))}
            </ul>
            <div className="mt-4 flex justify-between text-sm"><span>Subtotal</span><span>{formatMXN(open.subtotal)}</span></div>
            {open.discount > 0 && <div className="flex justify-between text-sm text-[#A94438]"><span>Descuento</span><span>−{formatMXN(open.discount)}</span></div>}
            <div className="flex justify-between text-sm"><span>Envío</span><span>{open.shipping_fee === 0 ? "Gratis" : formatMXN(open.shipping_fee)}</span></div>
            <div className="flex justify-between font-medium mt-2"><span>Total</span><span>{formatMXN(open.total)}</span></div>
          </div>
        </div>
      )}
    </div>
  );
}
